export enum Country {
    PE = 'PE',
    TH = 'TH',
    CO = 'CO',
    EC = 'EC',
    CL = 'CL',
    VE = 'VE',
}